export const INT_INPUT_REGEX = /^-?(0|[1-9]*\d*)$/;
export const NON_NEGATIVE_INT_INPUT_REGEX = /^(0|[1-9]\d*)$/;
export const FLOAT_INPUT_REGEX = /^-?(0|[1-9]*\d*)([.,]\d*)?$/;
export const NON_NEGATIVE_FLOAT_INPUT_REGEX = /^(0|[1-9]*\d*)(\.\d*)?$/;
export const EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
